<template>
  <autocomplete
    item-value="id"
    item-text="nome_cognome"
    :items="items"
    :loading="loading"
    :search-input.sync="searchInput"
    :value="value"
    v-bind="$attrs"
    v-on="$listeners">

    <template slot="item" slot-scope="{ item }">
      <v-list-tile-avatar size="36px" color="#757575">
        <v-img v-if="item.immagine_profilo" :src="item.immagine_profilo" @error="item.immagine_profilo = null"/>
        <v-icon v-else color="white">person</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="genItemHtml(item.nome_cognome)"/>
      </v-list-tile-content>
    </template>

  </autocomplete>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'TecniciSelect',
    props: {
        value: { required: false }
    },
    data: () => ({
        searchInput: null
    }),
    created () {
        this.$store.dispatch('loadTecnici').catch(e => {
            this.$snackbar.showServerError(e)
        })
    },
    computed: {
        ...mapState({
            items: state => state.global.tecnici,
            loading: state => state.global.loading.tecnici
        })
    },
    methods: {
        genItemHtml (text) {
            if (!this.searchInput) return text
            let maskedChars = this.getMaskedCharacters(text)
            return maskedChars.start + '<span class="v-list__tile__mask">' + maskedChars.middle + '</span>' + maskedChars.end
        },
        getMaskedCharacters (text) {
            let searchInput = (this.searchInput || '').toString().toLowerCase()
            let index = text.toLowerCase().indexOf(searchInput)
            if (index < 0) return { start: text, middle: '', end: '' }
            return {
                start: text.slice(0, index),
                middle: text.slice(index, index + searchInput.length),
                end: text.slice(index + searchInput.length)
            }
        }
    }
}
</script>
